import React from 'react';

const RoutePreview = React.lazy(() => import('@apps/Routes/RoutePreview'));
const RouteAdd = React.lazy(() => import('@apps/Routes/RouteAdd'));
const RouteEditorNew = React.lazy(() => import('@apps/Routes/RouteEditorNew'));
const RoutesList = React.lazy(() => import('@apps/Routes/RoutesList'));

import { IPohodnikRouterItem } from '.';
const routesRoutes: Array<IPohodnikRouterItem> = [
  {
    path: '/routes/add',
    component: () => <RouteAdd />,
    protected: true,
    title: 'Добавление маршрута',
  },
  {
    path: '/routes/new',
    component: () => <RouteEditorNew />,
    protected: true,
    title: 'Новый маршрут',
  },
  {
    path: '/routes/:id/edit',
    component: ({
      match: {
        params: { id },
      },
    }) => <RouteEditorNew id={id} />,
    protected: true,

    title: 'Редактирование маршрута',
  },
  {
    path: '/routes/:id',
    component: ({
      match: {
        params: { id },
      },
    }) => <RoutePreview id_route={id} />,
    protected: true,
    title: 'Просмотр информации о маршруте',
  },

  {
    path: '/routes',
    component: () => <RoutesList />,
    protected: false,
    title: 'Список маршрутов',
  },
];

export default routesRoutes;
